// extracted by mini-css-extract-plugin
export default {"container":"Lobby_container__52tf5","header":"Lobby_header__s8Qpr","heading":"Lobby_heading__OLe1e","menu":"Lobby_menu__OiKPd","toggle":"Lobby_toggle__20Bis"};